import { useState } from "react";

import ToolbarPopover from "../../ContextualToolbar/ToolbarPopover/ToolbarPopover";
import { Flex, isNullish, Radio, Text } from "@theorgchartdev/storybook";
import { GetDoc } from "@/Utils/StateLib";
import { planningTestId } from "@/appComponents/Navigation/RightSidebar/Utils/chartModeTestId";
import { useFilterController } from "./useFilterController";
import { useRightSidebarContext } from "@/providers/RightSidebarProvider";
import { useTopic } from "@/hooks/useTopic";
import { appstr } from "@coreapp/utils/appstr";
import { enumFilterModes } from "@coreapp/constants";

export const FilterSettingsPopover = () => {
  const filterMgr = GetDoc()?.GetFilterMgr();
  const filterController = useFilterController();

  const { settingsOpenCtrlRef, settingsFloatingCtrlRef } = useRightSidebarContext();

  const [currentMode, setCurrentMode] = useState<
    Nullable<(typeof enumFilterModes)[keyof typeof enumFilterModes]>
  >(() => {
    return filterMgr?.GetFilterMode() ?? null;
  });

  useTopic("FilterModeChange", (mode: (typeof enumFilterModes)[keyof typeof enumFilterModes]) => {
    setCurrentMode(mode);
  });

  const handleModeChange = (mode: (typeof enumFilterModes)[keyof typeof enumFilterModes]) => () => {
    if (isNullish(filterMgr)) {
      return;
    }

    filterMgr.SetFilterMode(mode);
    localStorage.setItem("fFilterMode", `${mode}`);
    filterController.debouncedApplyFilter();
  };

  return (
    <ToolbarPopover
      className="oc-filter-popover__overlay"
      otherPopoverProps={{
        openCtrlRef: settingsOpenCtrlRef,
        floatingCtrlRef: settingsFloatingCtrlRef,
        reference: null
      }}
    >
      <Flex direction={"column"} gap={"8px"}>
        <Text modifier={"medium"} size={"small"}>
          {appstr("Filter behavior")}
        </Text>
        <Radio
          label={appstr("Remove filtered records")}
          id="rsb-toggle-filter__settings-remove"
          data-testid={planningTestId("filter", "settings-remove-radio")}
          checked={currentMode === enumFilterModes.remove}
          onChange={handleModeChange(enumFilterModes.remove)}
        />
        <Radio
          label={appstr("Mute filtered records")}
          id="rsb-toggle-filter__settings-mute"
          data-testid={planningTestId("filter", "settings-mute-radio")}
          checked={currentMode === enumFilterModes.mute}
          onChange={handleModeChange(enumFilterModes.mute)}
        />
      </Flex>
    </ToolbarPopover>
  );
};
